<app-badge *ngIf="getDueDateIndication() as indication"
  [label]="indication.label"
  [variant]="variant"
  [customColor]="indication.color">
</app-badge>
